import { Instance, SnapshotIn, types } from "mobx-state-tree";
import {
  BoundedNameModel,
  createBoundedNameModel,
} from "../../models/BoundedNameModel";
import {
  createDeliveryStatsModel,
  DeliveryStatsModel,
} from "./DeliveryStatsModel";
import { EmailCycleStatus } from "@pulse/pulse-rpcs/lib/email-cycle/emailCycleStatus";
import { EmailCycle } from "@pulse/pulse-rpcs/lib/email-cycle/emailCycle";
import { EMPTY_CHARACTER } from "@pulse/shared-components";

export const EmailCycleModel = types
  .model("EmailCycleModel", {
    id: types.string,
    cycleName: BoundedNameModel,
    createdBy: types.string,
    createdAt: types.string,
    modifiedAt: types.string,
    scheduledAt: types.string,
    deliveryStats: DeliveryStatsModel,
    status: types.enumeration(
      "EmailCycleStatus",
      Object.values(EmailCycleStatus.EmailCycleStatus),
    ),
  })
  .actions((store) => ({
    setEmailCycle: (emailCycle: EmailCycle): void => {
      store.id = emailCycle.id.uuid;
      store.cycleName.setName(emailCycle.cycleName.name);
      store.createdBy = emailCycle.createdBy;
      store.createdAt = emailCycle.createdAt.timestamp;
      store.modifiedAt = emailCycle.modifiedAt.timestamp;
      store.scheduledAt = emailCycle.scheduledAt.timestamp;
      store.deliveryStats.setStats(emailCycle.deliveryStats);
      store.status = emailCycle.status;
    },
  }));

export const createEmailCycleModel = (
  emailCycle?: SnapshotIn<typeof EmailCycleModel>,
): Instance<typeof EmailCycleModel> =>
  EmailCycleModel.create(
    emailCycle ?? {
      id: EMPTY_CHARACTER,
      cycleName: createBoundedNameModel(),
      createdBy: EMPTY_CHARACTER,
      createdAt: EMPTY_CHARACTER,
      modifiedAt: EMPTY_CHARACTER,
      scheduledAt: EMPTY_CHARACTER,
      deliveryStats: createDeliveryStatsModel(),
      status: EmailCycleStatus.EmailCycleStatus.QUEUED,
    },
  );
